<template>
  <div style="display: inline-block">
    <icon-fill-star class="star" v-for="n in fillCount" :key="n" />
    <icon-empty-star class="star" v-for="j in (5 - fillCount)" :key="j" />
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Number,
    },
  },
  computed: {
    fillCount() {
      return Math.trunc(this.value);
    },
  },
};
</script>

<style scoped>
.star {
  display: inline-block;
  margin-left: 3px;
}
</style>
